/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { useSelector } from 'react-redux';

import { AuthDecorator } from '@components/auth-decorator';
import { LikeToken, UnlikeToken, UserLikesToken } from '@lib/versum';
import { RootState } from '@state/store';
import { Button } from '@versumstudios/ui';

import * as Styles from './styles';

interface IButtonLike {
  tokenId: string;
}

export const ButtonLike: FC<IButtonLike> = ({ tokenId }) => {
  const t = useTranslations('common');
  const [isSelected, setIsSelected] = useState<boolean>();
  const auth = useSelector((state: RootState) => state.auth);
  const userid = auth.user?.id;

  useEffect(() => {
    const load = async () => {
      if (userid) {
        const result = await UserLikesToken(userid, tokenId);
        const nextSelected = result.user_likes_token.length > 0;
        setIsSelected(nextSelected);
      }
    };
    load();
  }, [userid]);

  const handleClick = () => {
    setIsSelected(!isSelected);
    if (!isSelected) {
      LikeToken(tokenId);
    } else {
      UnlikeToken(tokenId);
    }
  };

  return (
    <Styles.Container selected={isSelected}>
      <AuthDecorator onClick={handleClick}>
        <Button variant="basic">
          <i>favorite</i>
          {isSelected ? t('unlike') : t('like')}
        </Button>
      </AuthDecorator>
    </Styles.Container>
  );
};
